<div class="modal-header">
  <h4 class="modal-title">{{"general.Crop Image" | translate}}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
</div>
<div class="modal-body">
  <div class="dataLoading h-100 py-5" *ngIf='!showCropper'>
    <div class="spinner-border"></div>
  </div>

  <div [hidden]="!showCropper">
    <image-cropper
      [maintainAspectRatio]="true"
      [aspectRatio]="ratio"
      [onlyScaleDown]="true"
      [resizeToWidth]="900"
      [imageFile]="image"
      [(transform)]="transform"
      (imageCropped)="imageCropped($event)"
      (imageLoaded)="imageLoaded()">
    </image-cropper>

    <div class="my-3 text-center">
      <button class="btn" (click)="zoomOut()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-zoom-out" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0"/>
          <path d="M10.344 11.742q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1 6.5 6.5 0 0 1-1.398 1.4z"/>
          <path fill-rule="evenodd" d="M3 6.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5"/>
        </svg>
      </button>
      <button class="btn" (click)="zoomIn()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-zoom-in" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0"/>
          <path d="M10.344 11.742q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1 6.5 6.5 0 0 1-1.398 1.4z"/>
          <path fill-rule="evenodd" d="M6.5 3a.5.5 0 0 1 .5.5V6h2.5a.5.5 0 0 1 0 1H7v2.5a.5.5 0 0 1-1 0V7H3.5a.5.5 0 0 1 0-1H6V3.5a.5.5 0 0 1 .5-.5"/>
        </svg></button>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="saveImage()">
    {{'general.OK' | translate}}
  </button>
  <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">
    {{"general.Cancel" | translate}}
  </button>
</div>
